import React from 'react'
import Modal from 'react-bootstrap/Modal'
import PropTypes from 'prop-types'
import close from 'src/assets/images/modal-close.png'
function CustomModal({ show, onHide, bodyContent, size, className = '' }) {
  return (
    <>
      <Modal show={show} size={size} onHide={onHide} className={className} centered>
        {className !== 'video-modal' && (
          <img src={close} alt="close-modal" className="close-modal" onClick={onHide}></img>
        )}

        <Modal.Body>{bodyContent}</Modal.Body>
      </Modal>
    </>
  )
}
CustomModal.propTypes = {
  show: PropTypes.bool.isRequired,
  onHide: PropTypes.func.isRequired,
  bodyContent: PropTypes.node,
  size: PropTypes.string.isRequired,
  className: PropTypes.string,
}

export default CustomModal
